module.exports = __webpack_public_path__ + "static/media/ar-flag.7b67db28.png";